import { combineReducers } from 'redux';
import addEdit from 'store/reducers/room/add-edit-room';
import deleteRoom from 'store/reducers/room/deleteRoom';
import roomFormData from 'store/reducers/room/formData';
import locationMatchesRooms from 'store/reducers/room/locationMatchesRooms';
import readReservationData from 'store/reducers/room/readReservationsData';
import readReservationsFilters from 'store/reducers/room/readReservationsFilters';
import locationRooms from 'store/reducers/room/locationRooms';
import massAdd from 'store/reducers/room/massAdd';
import exportExcel from 'store/reducers/room/exportExcel';
import reservationTableFilters from 'store/reducers/room/reservationTableFilters';
import reactivate from 'store/reducers/room/reactivate';
import getActivityLogs from 'store/reducers/room/get-activity-logs';
import roomDetails from 'store/reducers/room/get-details';
import locationMatchesRoomsForMassBooking from 'store/reducers/room/location-matches-rooms-for-mass-booking';
import readOccupancyRateData from 'store/reducers/room/readOccupancyRateData';
import readOccupancyRateFilters from 'store/reducers/room/readOccupancyRateFilters';
import occupancyRateTableFilters from 'store/reducers/room/occupancyRateTableFilters';
import getReservationsCount from "store/reducers/room/get-count";
import getActiveReservationsCount from "store/reducers/room/get-active-reservations-count";
import getReportExcel from "store/reducers/room/getReportExcel";

export default combineReducers({
  addEdit: addEdit,
  delete: deleteRoom,
  formData: roomFormData,
  locationMatchesRooms,
  locationRooms,
  readReservationData,
  readReservationsFilters,
  massAdd,
  exportExcel,
  reservationTableFilters,
  reactivate,
  getActivityLogs,
  roomDetails,
  locationMatchesRoomsForMassBooking,
  readOccupancyRateData,
  readOccupancyRateFilters,
  occupancyRateTableFilters,
  getCount: getReservationsCount,
  getActiveReservationsCount,
  getReportExcel,
});